import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {useParams} from "react-router-dom";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteRecord} from "../services/ProductLineItemsService.ts";
import {useProductLineItemsSelection} from "../hooks/useProductLineItemsSelection.ts";

export const DeleteRecordButton = () => {
    const {id: productId} = useParams();
    const {selectedRecords, clearSelection} = useProductLineItemsSelection();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async () => {
            await Promise.all(selectedRecords.map(record => deleteRecord(record.id)));
            clearSelection();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['product-line-items', productId]});
        }
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={mutation.mutate}
        />
    );
};